export enum ThemeColorsHospitalic {
    PRIMARY_300 = '#edf6f9',
    SECONDARY = '',

    // TEXT
    TEXT_PRIMARY = '#656868',
    TEXT_SECONDARY = '#ffffff',
    TEXT_DISABLED = 'rgba(42,46,53,0.38)',

    // Components:
    APP_BAR = '#006D77',
    DETAIL_LINK = '#53CBCB',
    TABLES = '#ceece9',

    // SURFACES

    PRIMARY = '#006D77',
    PRIMARY_MAIN = '#006D77',
    PRIMARY_DARK = '#056F70',
    PRIMARY_LIGHT = '#ddeceb',
    PRIMARY_DISABLED = 'rgba(12,25,60,0.12)',

    SECONDARY_MAIN = '#9B59B6',
    SECONDARY_DARK = '#6B2E85',
    SECONDARY_LIGHT = '#DEB9ED',
    SECONDARY_DISABLED = 'rgba(12,25,60,0.12)',

    DANGER_MAIN = '#D14023',
    DANGER_MEDIUM = '#EDB2A6',
    DANGER_LIGHT = '#FBEDEA',
    DANGER_DISABLED = 'rgba(12,25,60,0.12)',

    SUCCESS_MAIN = '#1D8634',
    SUCCESS_MEDIUM = '#A5CFAD',
    SUCCESS_LIGHT = '#E4F1E7',
    SUCCESS_DISABLED = 'rgba(12,25,60,0.12)',

    INFO_MAIN = '#2650D9',
    INFO_MEDIUM = '#A8B9F0',
    INFO_LIGHT = '#E9EDFB',
    INFO_DISABLED = 'rgba(12,25,60,0.12)',
    INFO_DARK = '#01579B',

    WARNING_MAIN = '#F6CD5A',
    WARNING_MEDIUM = '#FBEAB7',
    WARNING_LIGHT = '#FBEAB7',
    WARNING_DISABLED = 'rgba(12,25,60,0.12)',

    NEUTRAL_MAIN = '#737373',
    NEUTRAL_MEDIUM = '#E6E6E6',
    NEUTRAL_LIGHT = '#FAFAFA',
    NEUTRAL_DISABLED = 'rgba(12,25,60,0.12)',
}
